import axios from '@/repositories/client';
import media_repository from '@/repositories/media-repository';

import _ from 'lodash';

axios.getInvoices = (query, pagination, args) => {

  args.type = args.type || null;
  args.dropdown = args.dropdown || false;

  let options = {
    params: {
      search: query,
      type: args.type,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/invoices`, options)
    .then(response => {
      if (!args.dropdown)
        return response.data;
      else
        return response.data.data.map(invoice => ({text: invoice.reference_number, value: invoice.id}));
    });

};

axios.getInvoice = (invoice) => {
  return axios.get(`athena/v1/invoices/${invoice}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveInvoice = (invoice) => {

  const url = `athena/v1/invoices` + (invoice.id ? `/${invoice.id}` : '');
  const verb = invoice.id ? 'PUT' : 'POST';

  let data = _.cloneDeep(invoice);

  data.due_dates = invoice.due_dates.map(i => ({date: i.date, amount: i.amount})).filter(i => !!i.date && !!i.amount);
  data.invoices = invoice.invoices.map(i => ({id: i.id, amount: i.pivot.amount})).filter(i => !!i.id && !!i.amount);
  data.contracts = invoice.contracts.map(i => ({id: i.id, amount: i.pivot.amount})).filter(i => !!i.id && !!i.amount);
  data.reservations = invoice.reservations.map(i => ({id: i.id, amount: i.pivot.amount})).filter(i => !!i.id && !!i.amount);

  return axios.request({method: verb, url: url, data: data})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyInvoice = (invoice) => {
  invoice.files.forEach(file => { media_repository.deleteMedia(invoice.id, 'invoices', file); });
  return axios.delete(`athena/v1/invoices/${invoice.id}`)
    .then(response => {
      return response.data;
    });
};

export default axios;